import React, { useState } from "react";
import "./NewInfluencer.css";

const initialForm = {
  platform: "",
  username: "",
  name: "",
  mobile: "",
  email: "",
  url: "",
  rate: "",
  remarks: "",
  category: "",
  followers: "",
  engagement: ""
};

const AddInfluencerPage = () => {
  const [form, setForm] = useState(initialForm);
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState({ type: "", text: "" });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setMessage({ type: "", text: "" });

    const hasData = Object.values(form).some((val) => val && val.trim() !== "");
    if (!hasData) {
      setMessage({ type: "error", text: "Please fill at least one field before submitting." });
      setSubmitting(false);
      return;
    }

    try {
      const res = await fetch("https://core-bankers-backend.vercel.app/add-influencer", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form)
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Something went wrong");

      setMessage({ type: "success", text: "Influencer added successfully!" });
      setForm(initialForm);
    } catch (err) {
      setMessage({ type: "error", text: err.message });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="influencer-form-container">
      <h2>Add Influencer</h2>

      {message.text && (
        <div className={`form-message ${message.type}`}>
          {message.text}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Platform</label>
          <select name="platform" value={form.platform} onChange={handleChange}>
            <option value="">Select Platform</option>
            <option value="Instagram">Instagram</option>
            <option value="YouTube">YouTube</option>
            <option value="LinkedIn">LinkedIn</option>
            <option value="Other">Other</option>
          </select>
        </div>

        <div className="form-group">
          <label>Category</label>
          <select name="category" value={form.category} onChange={handleChange}>
            <option value="">Select Category</option>
            <option value="Lifestyle">Lifestyle</option>
            <option value="Finance">Finance</option>
            <option value="Technology">Technology</option>
            <option value="Fashion">Fashion</option>
            <option value="Health">Health</option>
            <option value="Other">Other</option>
          </select>
        </div>

        {[
          "username", "name", "mobile", "email", "url",
          "rate", "remarks", "followers", "engagement"
        ].map((field) => (
          <div key={field} className="form-group">
            <label>{field.charAt(0).toUpperCase() + field.slice(1)}</label>
            <input
              type="text"
              name={field}
              value={form[field] || ""}
              onChange={handleChange}
              placeholder={`Enter ${field}`}
            />
          </div>
        ))}

        <button type="submit" disabled={submitting}>
          {submitting ? "Saving..." : "Save Influencer"}
        </button>
      </form>
    </div>
  );
};

export default AddInfluencerPage;